import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
  useEffect,
} from "react";
import { registerContextMenu } from "./contextMenuService";

const ContextMenu = forwardRef((props, ref) => {
  const [menuData, setMenuData] = useState({
    visible: false,
    x: 0,
    y: 0,
    items: [],
  });
  const rootRef = useRef(null);

  useImperativeHandle(ref, () => ({
    show({ x, y, items }) {
      const { innerWidth, innerHeight } = window;
      const width = 200;
      const height = items.length * 32;

      const posX = x + width > innerWidth ? x - width : x;
      const posY = y + height > innerHeight ? y - height : y;

      setMenuData({ visible: true, x: posX, y: posY, items });
    },

    hide() {
      setMenuData((prev) => ({ ...prev, visible: false }));
    },
  }));

  useEffect(() => {
    registerContextMenu(ref.current);
  }, []);

  if (!menuData.visible) return null;

  return (
    <div
      ref={rootRef}
      className="ctx-menu"
      style={{ top: menuData.y, left: menuData.x }}
    >
      {menuData.items.map((item, index) => {
        if (!item) return null;
        if (item.id === "divider")
          return <div key={index} className="ctx-divider" />;

        return (
          <div
            key={index}
            className={`spp-btn ctx-item ${item.disabled ? "disabled" : ""}`}
            onClick={(e) => {              
              if (!item.disabled && item.callback) {
                item.callback();
                item.close()
              }
            }}
          >
            {item.label}
          </div>
        );
      })}
    </div>
  );
});

export default ContextMenu;
